import React, { useState } from "react";
import CampaignBanner from "./CampaignBanner";
import { ConciergeModal } from "../atelier/ConciergeModal";

/**
 * The concierge band.
 *
 * A campaign band whose call to action opens the M9 request form in place
 * rather than following a link. The service is a conversation, and routing the
 * shopper to a page that holds the same form only adds a step to it — so this
 * owns the modal state and reuses both the band and the modal that the product
 * page already uses. No second implementation of either.
 *
 * Editor-owned like every other section below the hero: an empty block renders
 * nothing, which is what keeps the band off the page if it is ever switched
 * off.
 */
export default function ConciergeBand({ block }) {
  const [open, setOpen] = useState(false);
  if (!block) return null;

  return (
    <>
      <CampaignBanner
        block={block}
        variant="concierge"
        testId="home-concierge"
        onCtaClick={() => setOpen(true)}
      />
      <ConciergeModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
